import { Controller } from "@hotwired/stimulus"
import PhotoSwipeLightbox from 'photoswipe/lightbox'
import PhotoSwipe from 'photoswipe'

export default class extends Controller {
  connect() {
    this.initPhotoSwipe()
  }

  initPhotoSwipe() {
    const lightbox = new PhotoSwipeLightbox({
      gallery: this.element,
      children: 'a',
      pswpModule: PhotoSwipe,
      preload: [0, 1], // Preloaduj jen aktuální a následující obrázek
      paddingFn: (viewportSize) => {
        return {
          top: 30,
          bottom: 30,
          left: 70,
          right: 70
        }
      },
      // Vypni preloading obrázků při hover
      preloadFirstSlide: false
    })

    lightbox.init()
    this.lightbox = lightbox
  }

  disconnect() {
    if (this.lightbox) {
      this.lightbox.destroy()
    }
  }
}

